var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToodhulisticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM11.9035 15.0958L16.5581 10.2958L15.1223 8.90346L11.1575 12.9922L8.84964 10.7953L7.47067 12.2439L10.4961 15.1239L11.2138 15.8071L11.9035 15.0958Z",
    fill: "#AD49E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToodhulisticon);
export default __webpack_public_path__ + "static/media/toodhulisticon.7c1b0edc48d77543a1b910920f347725.svg";
export { ForwardRef as ReactComponent };